/*
 * The MIT License
 *
 * Copyright (c) 2013, Sebastian Sdorra
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

'use strict';

angular.module('adf')
	.value('deleteUrl', '2/factndx/')

	.directive('ngReallyClick', [function () {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				element.bind('click', function () {
					var message = attrs.ngReallyMessage;
					if (message && confirm(message)) {
						scope.$apply(attrs.ngReallyClick);
					}
				});
			}
		};
	}])

	.directive('adfWidget', ['$compile', '$log', '$http', '$uibModal', '$timeout', 'dashboard', 'adfTemplatePath',
		'hostUrl', 'deleteUrl', 'dashboardFilterInitializationService', '$rootScope', 'chartService',
		'storeService',
		function ($compile, $log, $http, $uibModal, $timeout, dashboard, adfTemplatePath,
			hostUrl, deleteUrl, dashboardFilterInitializationService, $rootScope, chartService, storeService) {

			function stringToBoolean(string) {
				switch (string && string != null ? string.toLowerCase() : null) {
				case 'true':
				case 'yes':
				case '1':
					return true;
				case 'false':
				case 'no':
				case '0':
				case null:
					return false;
				default:
					return Boolean(string);
				}
			}

			function preLink($scope, $element, $attr) {
				var definition = $scope.definition;
				if (definition) {
					var w = dashboard.widgets[definition.config.type];
					if (w) {
						// pass title
						if (!definition.config.title) {
							definition.config.title = w.title;
						}

						// pass edit mode
						$attr.$observe('editMode', function (value) {
							$scope.editMode = stringToBoolean(value);
						});

						// pass copy of widget to scope
						$scope.widget = angular.copy(w);

						// create config object
						var config = definition.config;
						if (config) {
							if (angular.isString(config)) {
								config = angular.fromJson(config);
							}
						} else {
							config = {};
						}

						// pass config to scope
						$scope.config = config;
						$scope.isDrillDown = w.isDrillDown;
						$scope.nonRemovable = w.nonRemovable;
						if (w.isEditable) {
							$scope.isEditable = w.isEditable;
						}

						if (w.isPrintable) {
							$scope.isPrintable = w.isPrintable;
						}
						$scope.slideshowView = $rootScope.slideshowView;
						$scope.$on('slideshowViewChanged', function () {
							$scope.slideshowView = $rootScope.slideshowView;
						});
						$scope.printView = $rootScope.printView;
						$scope.$on('printViewChanged', function () {
							$scope.printView = $rootScope.printView;
						});
					} else {
						$log.warn('could not find widget ' + definition.type);
					}
				} else {
					$log.debug('definition not specified, widget was probably removed');
				}
			}

			function postLink($scope, $element, $attr) {
				var definition = $scope.definition;
				$scope.dbName = storeService.getState().reportSettings.reportName;
				$scope.isReadOnly = storeService.getState().reportSettings.readOnly;
				if (definition) {
					// bind close function
					$scope.close = function () {
						var confirmScope = $scope.$new();
						confirmScope.additionalText = 'delete this widget';
						confirmScope.buttonText = 'Delete';
						var column = $scope.col;
						var opts = {
							scope: confirmScope,
							templateUrl: '/application/f/core/confirm.html'
						};

						var instance = $uibModal.open(opts);
						confirmScope.closeDialog = function () {
							instance.close();
							confirmScope.$destroy();

							var widget = $scope.widget;
						};
						confirmScope.yes = function () {
							instance.close();
							confirmScope.$destroy();

							var widget = $scope.widget;
							if (column) {
								var index = column.widgets.indexOf(definition);
								storeService.dispatch({
									type: storeService.actions.CONFIG_WIDGET_DELETE_ONE,
									payload: {
										column: 'column' + column.columnIndex,
										position: index
									},
									meta: {
										reportName: undefined,
										reportSettingsId: globalReportName
									}
								});
								if (index >= 0) {
									var widgetType = definition.config.type;
									dashboardFilterInitializationService.removeWidgetFilters(widgetType);
									column.widgets.splice(index, 1);
									pendo.track('widgetDelete', {
										widgetType: definition.config.type,
										dashboardParentName: storeService.getState().reportSettings.baseReportName
									});
									$scope.$parent.$parent.$broadcast('widgetRemoved');
								}
							}
							$element.remove();
						};

					};

					// bind reload function
					$scope.reload = function () {
						$scope.$broadcast('widgetReload');
					};
					// bind reload function
					$scope.drillDownReport = function () {
						pendo.track('widgetInteraction', {
							widgetType: $scope.config.type,
							dashboardParentName: storeService.getState().reportSettings.baseReportName,
							interaction: 'reportDrilldown'
						});
						if (typeof $scope.widget.drillDownReport == 'function') {
							$scope.widget.drillDownReport();
						} else {
							window.open($scope.widget.drillDownUrl, '_blank');
						}
					};

					$scope.print = function () {

						chartService.clearChartsForPrint();

						var printWidgetScope = $scope.$new();
						printWidgetScope.widgets = [];
						printWidgetScope.widgets.push(angular.copy($scope.definition));
						printWidgetScope.print = function () {
							window.print();
						};

						var instance = $uibModal.open({
							scope: printWidgetScope,
							templateUrl: '/application/f/dashboard/widgets/widget-print.html',
							windowTemplateUrl: '/application/f/dashboard/widgets/widget-print-template.html'
						});

						$rootScope.printView = true;
						$rootScope.$broadcast('printViewChanged');

						setupPrint(true);

						// Listener for Print Setup
						var afterPrint = function () {
							instance.close();
							setupPrint(false);
							printWidgetScope.$destroy();
						};

						if (window.matchMedia) {
							var mediaQueryList = window.matchMedia('print');
							mediaQueryList.addListener(function (mql) {
								if (mql.matches) {} else {
									afterPrint();
								}
							});
						}

						window.onafterprint = afterPrint;

						instance.result.then(function () {
							instance.close();
							setupPrint(false);
							printWidgetScope.$destroy();
						}, function () {
							instance.close();
							printWidgetScope.$destroy();
							// Adding timeout to make sure instance is closed and control goes back to normal
							$timeout(function () {
								setupPrint(false);
							}, 0);
						});
					};


					$scope.isMobile = function () {
						return isMobile();
					};

					// bind edit function
					$scope.edit = function () {
						var editScope = $scope.$new();

						var opts = {
							scope: editScope,
							templateUrl: adfTemplatePath + 'widget-edit.html'
						};

						var instance = $uibModal.open(opts);
						editScope.closeDialog = function () {
							instance.close();
							editScope.$destroy();

							var widget = $scope.widget;
							if (widget.edit && widget.edit.reload) {
								// reload content after edit dialog is closed
								$scope.$broadcast('widgetConfigChanged');
							}
						};
					};
				} else {
					$log.debug('widget not found');
				}


				/**
				 * Tidies up page for printing
				 * 
				 * @param {*} status - True for opening print, False for closing print
				 */
				function setupPrint(status) {
					if (status) {
						// Hide background for printing
						document.getElementById('topView').style.display = 'none';
						document.getElementById('sideView').style.display = 'none';
						document.getElementById('mainView').style.display = 'none';
						jQuery('.metric-settings').css('display', 'none');
						// Hide Widget Controls
						document.getElementById('widgetControl').style.display = 'none';
					} else {
						// Show background
						document.getElementById('topView').style.display = 'block';
						document.getElementById('sideView').style.display = 'block';
						document.getElementById('mainView').style.display = 'block';
						jQuery('.metric-settings').css('display', 'block');

						$timeout(function () {
							$rootScope.printView = false;
							$rootScope.$broadcast('metricFilterChanged');
							$rootScope.$broadcast('printViewChanged');
							// Show Widget Controls
							document.getElementById('widgetControl').style.display = 'block';
						}, 0);
					}

				}

				$scope.$on('$destroy', function () {
					if (typeof $scope.chart != 'undefined' && $scope.chart != null) {
						$scope.chart = $scope.slideshowView ? $scope.chart.destroy() : $scope.chart.unload();
						$scope.chart = null;
					}
				});
			}

			return {
				replace: true,
				restrict: 'EA',
				transclude: false,
				templateUrl: adfTemplatePath + 'widget.html',
				scope: {
					definition: '=',
					col: '=column',
					editMode: '@'
				},
				compile: function compile($element, $attr, transclude) {

					/**
					 * use pre link, because link of widget-content
					 * is executed before post link widget
					 */
					return {
						pre: preLink,
						post: postLink
					};
				}
			};

		}
	]);
